import { Route, HashRouter as Router, Routes, useParams } from "react-router-dom";

import { InternalScreen } from "./components/Interna/InternalScreen";
import ChatBot from "./components/ChatBot";

import Apresentacoes from "./pages/ApresentacoesMensais";
import Biblioteca from "./pages/Biblioteca";
import Calendario from "./pages/Calendario";
import Profile from "./pages/Conta";
import Dashboard from "./pages/Dashboard";
import Informativos from "./pages/Informativos";
import Leituras from "./pages/LeiturasTecnicas";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import StatisticalData from "./pages/StatisticalData";
import ReportDiario from "./pages/ReportDiario";

import { ApresentacoesMensaisProvider } from "./context/ApresentacoesMensaisContext";
import { BibliotecaProvider } from "./context/BibliotecaContext";
import { CalendarioProvider } from "./context/CalendarioContext";
import { ContaProvider } from "./context/ContaContext";
import { DashboardProvider } from "./context/DashboardContext";
import { InformativoProvider } from "./context/InformativoContext";
import { LeisTraduzidasProvider } from "./context/LeisTraduzidasContext";
import { LeiturasTecnicasProvider } from "./context/LeiturasTecnicasContext";
import { LoginProvider } from "./context/LoginContext";
import { ResetPasswordProvider } from "./context/ResetPasswordContext";
import { StatisticalDataProvider } from "./context/StatisticalDataContext";
import Trial from "./pages/Trial";
import ReformaTributaria from "./pages/ReformaTributaria";
import ProjetoDeLei from "./pages/ProjetoDeLei";
import ProjetoDeLeiDetalhe from "./pages/ProjetoDeLeiDetalhe";
import Notificacoes from "./pages/Notificacoes";
import TrialLatam from "./pages/TrialLatam";

const TrialWithParams = () => {
    const { encryptedData } = useParams();
    return <Trial encryptedData={encryptedData} />;
};

const TrialLatamWithParams = () => {
    const { encryptedData } = useParams();
    return <TrialLatam encryptedData={encryptedData} />;
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={
                    <LoginProvider>
                        <Login />
                    </LoginProvider>
                } />

                <Route exact path="/" element={
                    <LoginProvider>
                        <Login />
                    </LoginProvider>
                } />

                <Route path="/reset/password" element={
                    <ResetPasswordProvider>
                        <ResetPassword />
                    </ResetPasswordProvider>
                } />

                <Route path="/dashboard" element={
                    <DashboardProvider>
                        <Dashboard />
                    </DashboardProvider>
                } />

                <Route path="/biblioteca" element={
                    <BibliotecaProvider>
                        <Biblioteca />
                    </BibliotecaProvider>
                } />

                <Route path="/projetodelei" element={
                    <ProjetoDeLei />
                } />

                <Route path="/notificacoes" element={
                    <Notificacoes />
                } />

                <Route path="/projetodelei/:id" element={
                    <ProjetoDeLeiDetalhe />
                } />

                <Route path="/calendario" element={
                    <CalendarioProvider>
                        <Calendario />
                    </CalendarioProvider>
                } />

                <Route path="/data" element={
                    <StatisticalDataProvider>
                        <StatisticalData />
                    </StatisticalDataProvider>
                } />

                <Route path="/apresentacoes" element={
                    <ApresentacoesMensaisProvider>
                        <Apresentacoes />
                    </ApresentacoesMensaisProvider>
                } />

                <Route path="/informativos" element={
                    <InformativoProvider>
                        <Informativos />
                    </InformativoProvider>
                } />

                <Route path="/report-diario/:id/:hash" element={
                    <ReportDiario />
                } />

                {/* Entrará em uma versão futura */}
                {/* <Route path="/leis" element={
                    <LeisTraduzidasProvider>
                        <LeisTraduzidas />
                    </LeisTraduzidasProvider>
                } /> */}

                <Route path="/ebooks" element={
                    <LeiturasTecnicasProvider>
                        <Leituras />
                    </LeiturasTecnicasProvider>
                } />

                <Route path="/profile" element={
                    <ContaProvider>
                        <Profile />
                    </ContaProvider>
                } />

                <Route path="/reforma-tributaria" element={
                    <BibliotecaProvider>
                        <ReformaTributaria />
                    </BibliotecaProvider>
                } />

                <Route path="/trial/:encryptedData" element={
                    <TrialWithParams />
                } />

                <Route path="/trial-latam/:encryptedData" element={
                    <TrialLatamWithParams />
                } />

                <Route path="/documento/:path/:id" element={<InternalScreen />} />
            </Routes>
        </Router>
    );
}

export default App;
